<template>
  <div class="page-container">
    <div class="query-title">销售计划战区变更控制表</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="结果清单"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="add" tip="新增" @click="addRow" />
            <table-button name="save" tip="保存" @click="tableAction('SAVE')" />
            <table-button name="cancle" tip="作废" @click="tableAction('REJECT')" />
            <table-button name="import" tip="批量导入" @click="handleImportExcel" />
            <table-button name="download" tip="模版下载" @click="downloadTemplate" />
            <table-button name="delete" tip="删除" @click="tableAction('DELETE')" />
            <table-button name="apply" tip="修改" @click="editRow" />
          </template>
          <vxe-grid
            v-if="tableMode === 'query'"
            ref="xTable"
            key="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          />
          <vxe-grid
            v-if="tableMode === 'edit'"
            key="xTable2"
            ref="xTable2"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{name: 'NotData'}"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="tableEditData.columns"
            :data="tableEditData.data"
          >
            <template #gjahr="{row}">
              <el-date-picker
                v-model="row.gjahr"
                type="year"
                value-format="yyyy"
                size="mini"
              />
            </template>
            <template #monat="{row}">
              <el-select
                v-model="row.monat"
                size="mini"
              >
                <el-option v-for="item in selectDataOptions['month']" :key="item.value" :value="item.value" :label="item.label" />
              </el-select>
            </template>
            <template #wlybrand="{row}">
              <el-select
                v-model="row.wlybrand"
                size="mini"
                filterable
                @change="changeWlybrand($event, row)"
              >
                <el-option v-for="item in selectDataOptions['A0019']" :key="item.value" :value="item.value" :label="item.value">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
            </template>
            <template #plan_type="{row}">
              <el-select
                v-model="row.plan_type"
                size="mini"
              >
                <el-option v-for="item in selectDataOptions['A0002']" :key="item.value" :value="item.value" :label="item.name" />
              </el-select>
            </template>
            <template #customer_type="{row}">
              <el-select
                v-model="row.customer_type"
                size="mini"
              >
                <el-option v-for="item in selectDataOptions['A0009']" :key="item.value" :value="item.value" :label="item.name" />
              </el-select>
            </template>
            <template #sal_center="{row}">
              <el-select
                v-model="row.sal_center"
                size="mini"
                @change="changeSale($event, row)"
              >
                <el-option v-for="item in row['saleList']" :key="item.SOBID" :value="item.SOBID" :label="item.MC_SHORT" />
              </el-select>
            </template>
            <template #zzfld00003e="{row}">
              <el-select
                v-model="row.zzfld00003e"
                size="mini"
              >
                <el-option v-for="item in row['baseList']" :key="item.SOBID" :value="item.SOBID" :label="item.MC_SHORT" />
              </el-select>
            </template>
            <template #trs_customer="{row}">
              <wly-input
                v-model="row.trs_customer"
                input-type="customer"
                @enter="handleEnter(...arguments, row)"
                @handleSuffixClick="openDialog($event, row)"
              />
            </template>
            <template #datum="{row}">
              <el-date-picker
                v-model="row.datum"
                type="date"
                size="mini"
                format="yyyy-MM-dd"
                value-format="yyyyMMdd"
              />
            </template>
            <template #mdate="{row}">
              <el-date-picker
                v-model="row.mdate"
                type="date"
                size="mini"
                format="yyyy-MM-dd"
                value-format="yyyyMMdd"
              />
            </template>
            <template #remark="{row}">
              <el-input
                v-model="row.remark"
                size="mini"
              />
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

    <el-dialog v-dialogDrag :visible.sync="showDialog" title="客户选择" width="70%">
      <template v-if="showDialog">
        <client-select ref="dialogSelect" />
      </template>
      <div slot="footer">
        <el-button size="small" type="primary" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiSalePlanChangeTheater, apiSalePlanChangeTheaterFunc } from '@/api/sap/sale-plan'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
import {
  apiExcelImport,
  apiGetExcelImportData,
  apiExportExcelTemplate
} from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { month } from './config/salePlanChangeTheaterReport'
import ClientSelect from '@/components/dialog/ClientSelect'
import { frontExport } from '@/utils/frontExport'
export default {
  components: { ClientSelect },
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      tableMode: 'query',
      showDialog: false,
      batchConditions: {
        batchNumber: '',
        templateCode: 'salePlanChangeZQ'
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 }
        ],
        data: []
      },
      selectDataOptions: {
        month
      },
      tableEditData: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 },
          { field: 'gjahr', title: '年度', width: 120, slots: { default: 'gjahr' }},
          { field: 'monat', title: '月份', width: 120, slots: { default: 'monat' }},
          { field: 'wlybrand', title: '存货分类', width: 120, slots: { default: 'wlybrand' }},
          { field: 'wlybrand_txt', title: '存货分类', width: 200 },
          { field: 'plan_type', title: '计划类型', width: 200, slots: { default: 'plan_type' }},
          { field: 'customer_type', title: '客户类型', width: 120, slots: { default: 'customer_type' }},
          { field: 'sal_center', title: '战区', width: 150, slots: { default: 'sal_center' }},
          { field: 'zzfld00003e', title: '基地', width: 120, slots: { default: 'zzfld00003e' }},
          { field: 'trs_customer', title: '订单客户编码', width: 150, slots: { default: 'trs_customer' }},
          { field: 'cust_name', title: '订单客户名称', width: 250 },
          { field: 'create_name', title: '创建人', width: 120 },
          { field: 'erdat', title: '创建日期', width: 120 },
          { field: 'datum', title: '生效日期', width: 120, slots: { default: 'datum' }},
          { field: 'mdate', title: '失效日期', width: 120, slots: { default: 'mdate' }},
          { field: 'status_text', title: '生效状态', width: 120 },
          { field: 'remark', title: '备注', width: 250, slots: { default: 'remark' }}
        ],
        data: []
      },
      currentRow: null,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0002')
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0009')
    apiGetOrgOrBase('', 1, { _t: new Date().getTime() }).then(res => {
      this.$set(this.selectDataOptions, 'saleList', res.DATA)
    })
    this.initPage(pageConfig)
  },
  methods: {
    addRow() {
      this.tableMode = 'edit'
      const data = {
        index: this.tableEditData.data.length ? this.tableEditData.data.at(-1).index - 0 + 1 : 1,
        gjahr: '',
        monat: '',
        wlybrand: '',
        wlybrand_txt: '',
        plan_type: '',
        customer_type: '',
        sal_center: '',
        zzfld00003e: '',
        trs_customer: '',
        cust_name: '',
        create_name: '',
        erdat: '',
        datum: '',
        mdate: '',
        status: '',
        remark: '',
        saleList: this.selectDataOptions['saleList'] || [],
        baseList: []
      }
      this.tableEditData.data.push(data)
    },
    async editRow() {
      if (this.tableMode === 'edit') return
      const selects = this.$refs.xTable.getCheckboxRecords()
      if (!selects.length) {
        return this.$message.warning('请选择有效数据！')
      }

      this.tableMode = 'edit'
      for (const index in selects) {
        const obj = {
          ...selects[index],
          index: index + 1,
          saleList: this.selectDataOptions['saleList']
        }
        if (obj.sal_center) {
          const { DATA } = await apiGetOrgOrBase(obj.sal_center, 2, { _t: new Date().getTime() })
          obj.baseList = DATA
        }
        this.tableEditData.data.push(obj)
      }
    },
    async tableAction(mode) {
      let selects
      let items
      if (this.tableMode === 'query') {
        selects = this.$refs.xTable.getCheckboxRecords()
        items = this.gridOptions.data
      } else {
        selects = this.$refs.xTable2.getCheckboxRecords()
        items = this.tableEditData.data
      }
      if (!selects.length) {
        return this.$message.warning('请选择有效数据！')
      }

      // 检查是否有guid如果有就调用接口删除，如没有，就调用
      if (mode === 'DELETE' && selects.every(item => !item.guid)) {
        selects.forEach(item => {
          const index = this.tableEditData.data.findIndex(v => v._X_ID === item._X_ID)
          this.tableEditData.data.splice(index, 1)
        })
        return
      }

      const params = {
        mode,
        user_bp: this.$store.getters.role.USER_BP,
        selects,
        items
      }
      const res = await apiSalePlanChangeTheaterFunc(params)
      if (res.msgtype !== 'E') {
        this.$message.success(res.message)
        // 如果是操作的查询表格，就重新调用查询
        this.tableMode === 'query' && this.queryData()

        if (mode === 'SAVE') {
          // 将返回的数据进行对应替换
          selects.forEach(row => {
            const index = res.data.findIndex(v => (v.index - 0) === row.index)
            Object.assign(row, res.data[index])
            row.index -= 0
          })
        } else if (mode === 'DELETE') {
          selects.forEach(item => {
            const index = this.tableEditData.data.findIndex(v => v._X_ID === item._X_ID)
            this.tableEditData.data.splice(index, 1)
          })
        }
      } else {
        this.$message.error(res.message)
      }
    },
    changeWlybrand(e, row) {
      this.currentRow = row
      if (e) {
        this.currentRow['wlybrand_txt'] = this.selectDataOptions['A0019'].find(item => item.value === e).name
      } else {
        this.currentRow['wlybrand_txt'] = ''
      }
    },
    changeSale(e, row) {
      this.currentRow = row
      if (e) {
        apiGetOrgOrBase(e, 2).then(res => {
          this.currentRow['baseList'] = res.DATA
        })
      } else {
        this.currentRow['baseList'] = []
      }
    },
    async queryData(page, ranges) {
      this.tableMode = 'query'
      this.tableEditData.data = []
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiSalePlanChangeTheater(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    // 导入excel
    async handleImportExcel(type, btn) {
      this.$refs[this.tableMode === 'query' ? 'xTable' : 'xTable2']
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: 'salePlanChangeZQ'
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.batchConditions.batchNumber = res.data
            // this.batchConditions.templateCode = type
            this.handleQueryImportExcel()
          }
        })
    },
    // 根据批次号查询数据并且保存
    async handleQueryImportExcel() {
      const params = {
        ...this.batchConditions,
        page: 1,
        pagesize: 10000
      }

      const { data } = await apiGetExcelImportData(params)
      // 转换一哈驼峰
      for (const item of data.Rows) {
        // 转换大小写
        Object.keys(item).forEach(key => {
          item[this.toLineAndUp(key)] = item[key]
          if (this.toLineAndUp(key) !== key) {
            delete item[key]
          }
        })
      }

      // 调用sap接口
      const params2 = {
        mode: 'IMPORT',
        user_bp: this.$store.getters.role.USER_BP,
        import_items: data.Rows
      }

      const res = await apiSalePlanChangeTheaterFunc(params2)

      if (res.msgtype !== 'E') {
        this.$message.success(res.message)
        this.queryData()
      } else {
        this.$message.error(res.message)
      }
    },
    // 驼峰转成下划线
    toLineAndUp(str = '') {
      return str.replace(/([A-Z])/g, '_$1').toLowerCase()
    },
    // 模板下崽
    async downloadTemplate() {
      const type = 'salePlanChangeZQ'
      const fileName = '销售计划战区变更控制'
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${res.data.file}&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    openDialog(e, row) {
      this.showDialog = true
      this.currentRow = row
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        this.currentRow.trs_customer = data.customerCode
        this.currentRow.cust_name = data.customerName
      }
      this.showDialog = false
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return
      this.currentRow = row
      this.currentRow.trs_customer = data.customerCode
      this.currentRow.cust_name = data.customerName
    },
    async getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      formData.append('_t', new Date().getTime())
      const res = await apiLoadDictionaryDtl(formData)
      this.$set(this.selectDataOptions, dictcode, res.data.Rows)
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanChangeTheaterReport.vue